import React from 'react';

import useWalletNormalization from '../../providers/providers-list/wallets/use-wallet-normalization';
import ServiceVisibilityModalContextProvider from '../../providers/service-visibility-modal/context-provider';
import CarrierTable from './carrier-table';
import { useSellerWallets } from '../../../../hooks/use-seller-wallets';

const WalletCarriersContent = () => {
  useWalletNormalization();
  const wallets = useSellerWallets();

  return (
    <ServiceVisibilityModalContextProvider>
      {wallets.map((wallet, index) => {
        const { walletId, newLabelProviderIds, resources } = wallet;
        return (
          <CarrierTable
            key={walletId ?? index}
            eligibleProviderIds={newLabelProviderIds}
            walletId={walletId}
            walletSellerLabelProviderIds={resources?.sellerLabelProviderIds}
          />
        );
      })}
    </ServiceVisibilityModalContextProvider>
  );
};

export default WalletCarriersContent;
